var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "row row-wrap"
  }, [_c('a', {
    staticClass: "col-xs-12 aItem row sideless ellipsis",
    staticStyle: {
      "margin": "0px",
      "text-align": "left"
    },
    attrs: {
      "id": _vm.branch.sid + 'Side'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.item_clicked(_vm.branch)
      }
    }
  }, [_c('div', {
    staticClass: "icon-text-container",
    class: {
      'active-tree-item fsable': (_vm.branch.sid == _vm.$root.active_tree_item.id && (_vm.$route.query.p == _vm.branch.idp || _vm.$route.query.p == null) && (_vm.$route.params.focus == null))
    },
    staticStyle: {
      "white-space": "nowrap",
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "0px"
    }
  }, [(!_vm.isFirstSon) ? _c('div', {
    staticClass: "sideless side-branch",
    class: {
      'last': _vm.isLastSon
    }
  }, [_c('div', {
    staticClass: "branch top"
  }), _vm._v(" "), _c('div', {
    staticClass: "branch bot"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    class: _vm.$root.prod_icons[_vm.branch.typ] ? _vm.$root.prod_icons[_vm.branch.typ].icn : _vm.$root.icons.dir
  })]), _vm._v(" "), (_vm.branch.children) ? _c('span', {
    staticStyle: {
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.arrow_clicked()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.children.length == 0 && _vm.uses.length == 0 ? _vm.$root.icons.right : _vm.$root.icons.down]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hide-collapse",
    staticStyle: {
      "visibility": "initial"
    },
    style: (_vm.branch.ist || _vm.children.length == 0 ? {
      'font-weight': 650
    } : '')
  }, [(_vm.$Components['supportSidebar.impieghi'].showRedQty) ? _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "right",
      "trigger": "hover",
      "content": _vm.$Jed.firstUpperTranslate('total quantity'),
      "popoverCondition": _vm.info_qty,
      "popoverStyle": {
        'max-width': '120px',
        'width': '120px',
        'font-size': 'small',
        'height': '40px',
        'position': 'absolute'
      },
      "showOK": false,
      "showNO": false,
      "textStyle": {
        color: '#222'
      }
    }
  }, [(_vm.branch.qty) ? _c('span', {
    style: (_vm.$Components['supportSidebar.impieghi'].showRedQty ? {
      'margin-left': '5px',
      'margin-right': '5px',
      'padding': '5px',
      'color': 'red',
      'font-weight': 650
    } : ''),
    attrs: {
      "id": "popoup_in_right_sidebar"
    },
    on: {
      "mouseover": _vm.mouse_over
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$Components['supportSidebar.impieghi'].showRedQty ? _vm.branch.qty : ' - ' + _vm.branch.qty) + "\n                            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$Components['supportSidebar.impieghi'].showId && _vm.$Components['supportSidebar.impieghi'].showDes) ? _c('span', [_vm._v(_vm._s(_vm.branch.sid + ' - ' + _vm.branch.des))]) : (_vm.$Components['supportSidebar.impieghi'].showId) ? _c('span', [_vm._v(_vm._s(_vm.branch.sid))]) : (_vm.$Components['supportSidebar.impieghi'].showDes) ? _c('span', [_vm._v(_vm._s(_vm.branch.des))]) : _vm._e(), _vm._v(" "), (_vm.branch.qty && !_vm.$Components['supportSidebar.impieghi'].showRedQty) ? _c('span', [_vm._v(_vm._s(' - ' + _vm.branch.qty))]) : _vm._e(), _vm._v(" "), (_vm.branch.pos) ? _c('span', [_vm._v(_vm._s(' - ' + _vm.branch.pos))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    class: {
      'first': _vm.isFirstSon, 'child': !_vm.isFirstSon, 'fatherlast': _vm.isLastSon
    }
  }, [_vm._l((_vm.children), function(child, index) {
    return _c('li', {
      staticClass: "pageLink"
    }, [_c('use-item', {
      key: index,
      attrs: {
        "branch": child,
        "isFirstSon": false,
        "isLastSon": index == _vm.children.length - 1 && (_vm.uses == null || _vm.uses.length == 0)
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.uses), function(child, index) {
    return _c('li', {
      staticClass: "pageLink"
    }, [_c('div', {
      staticClass: "row row-wrap"
    }, [_c('a', {
      staticClass: "col-xs-12 aItem row sideless ellipsis",
      staticStyle: {
        "margin": "0px",
        "text-align": "left"
      },
      attrs: {
        "id": child.sid + 'Side'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.item_clicked(child)
        }
      }
    }, [_c('div', {
      staticClass: "icon-text-container",
      class: {
        'active-tree-item fsable': (child.sid == _vm.$root.active_tree_item.id && (_vm.$route.query.p == child.idp || _vm.$route.query.p == null) && (_vm.$route.params.focus == null || !_vm.isChild)),
        'active-tree-use fsable': (_vm.branch.sid == _vm.$root.active_tree_item.id && (_vm.$route.query.p == _vm.branch.idp || _vm.$route.query.p == null) && (_vm.$route.params.focus == child.pos))
      }
    }, [_c('span', {
      staticStyle: {
        "padding": "0px"
      }
    }, [(!_vm.isFirstSon) ? _c('div', {
      staticClass: "sideless side-branch",
      class: {
        'last': index == _vm.uses.length - 1
      }
    }, [_c('div', {
      staticClass: "branch top"
    }), _vm._v(" "), _c('div', {
      staticClass: "branch bot"
    })]) : _vm._e(), _vm._v(" "), _c('i', {
      class: [child.cco != null && child.cco > 0 ? _vm.$root.icons.dir : _vm.$root.icons.leaf]
    })]), _vm._v(" "), _c('div', {
      staticClass: "hide-collapse",
      staticStyle: {
        "visibility": "initial"
      }
    }, [_vm._v(_vm._s(child.des)), (child.pos) ? _c('span', [_vm._v(_vm._s(' - ' + child.pos))]) : _vm._e(), (child.qty) ? _c('span', [_vm._v(_vm._s(' - ' + child.qty))]) : _vm._e()])])])])])
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7126c571","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-sup-components/use-list-item.vue
// module id = 1441
// module chunks = 1